
import { GET_RTB_LOG } from './actionTypes';
import { getActionStatusName } from '@/store/helpers';

export const getRtbLogStatus = state => state.status[getActionStatusName(GET_RTB_LOG)] || {};